<template>
  <div
    :class="{
      'indicator-wrap': true,
      'indicator-wrap-horizontal': direction === 'horizontal',
    }"
  >
    <div v-for="(item, index) in data" :key="index" class="indicator-item">
      <div class="indicator-title-container">
        <span class="indicator-title">{{ item.name }}</span>
        <i
          v-if="item.desc && direction !== 'horizontal'"
          class="crm-question"
          @click="showDesc(item)"
        ></i>
      </div>
      <div class="indicator-value-wrap">
        <div class="indicator-content">
          <div class="indicator-value">
            {{ renderValueByBottom(item.value) }}
          </div>
          <div v-if="item.unit" class="indicator-unit">{{ item.unit }}</div>
          <div
            v-if="showCompareInfo"
            :class="{
              'indicator-gap': true,
              up: item.rateValue && item.rateValue > 0,
              down: item.rateValue && item.rateValue < 0,
            }"
          >
            <i
              v-if="item.rateValue"
              :class="{
                'crm-Up': item.rateValue && item.rateValue > 0,
                'crm-down': item.rateValue && item.rateValue < 0,
              }"
            ></i>
          </div>
        </div>
        <div v-if="item.rateValue && showCompareInfo" class="indicator-rate">
          {{ getCompareDesc(item.rateValue) }}
        </div>
      </div>
    </div>
    <!-- 指标名称解释 -->
    <IndicatorDesc v-if="direction !== 'horizontal'" :data="descData" :show="show" @close="close" />
  </div>
</template>

<script>
import IndicatorDesc from './IndicatorDesc.vue'
import { isNil } from 'lodash'

/**
  * name: '指标名称',
    value: '值',
    unit: '单位',
    rateValue: '比例'
 */
export default {
  components: {
    IndicatorDesc,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    direction: {
      type: String,
      default: 'vertical',
    },
    showCompareInfo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: false,
      descData: {},
    }
  },
  methods: {
    showDesc(item) {
      this.descData = item
      this.show = true
    },
    close() {
      this.show = false
    },
    getCompareDesc(val) {
      if (val !== undefined) {
        if (val > 0) {
          return this.$t('Gattaran_opt_AGTs_VRUG' /** 较上期增加{{环比变化%}} */, {
            change: ` ${val}% `,
          })
        } else if (val < 0) {
          return this.$t('Gattaran_opt_SrLe_Wnrt' /** 较上期减少{{环比变化%}} */, {
            change: ` ${Math.abs(val)}% `,
          })
        } else {
          return this.$t('FoodB_0905__yxOa' /** 与上一统计周期相比，单量不变 */)
        }
      }
    },
    renderValueByBottom(numberVal) {
      return isNil(numberVal) ? '--' : numberVal
    },
  },
}
</script>

<style lang="scss" scoped>
.indicator-wrap {
  position: relative;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .indicator-item {
    position: relative;
    width: calc(50% - 8px);
    margin-top: 48px;
    &:nth-child(1),
    &:nth-child(2) {
      margin-top: 0;
    }

    .indicator-title-container {
      margin-right: 4px;
      padding-right: 24px;
      margin-bottom: 8px;
      font-size: 24px;
      font-weight: 500;
      display: flex;
    }
    .indicator-title {
      font-family: DiDiSans-Pro-Medium;
      color: #8d9099;
      white-space: nowrap;
      overflow: hidden;
      white-space: pre-wrap;
      text-overflow: ellipsis;
      text-align: left;
      margin-right: 6px;
    }
    .indicator-value-wrap {
      position: relative;
      .indicator-content {
        display: flex;
        align-items: flex-end;
        margin-bottom: 8px;
        min-height: 20px;
        .indicator-value {
          font-family: DiDiSans-Pro-Bold;
          font-size: 56px;
          color: #282b33;
          font-weight: 700;
          margin-right: 8px;
          white-space: nowrap;
          padding-top: 3px;
        }
        .indicator-unit {
          font-family: DiDiSans-Pro-Regular;
          font-size: 28px;
          color: #8d9099;
          font-weight: 400;
          margin-right: 8px;
        }
        .indicator-gap {
          display: flex;
          padding-bottom: 4px;
          &.up {
            i {
              color: #09ba78;
            }
          }
          &.down {
            i {
              color: #f93c32;
            }
          }
          i {
            width: 16px;
            height: 16px;
            font-size: 16px;
            color: #85878e;
          }
        }
      }

      .indicator-period-info {
        font-family: DiDiSans-Pro-Thin;
        font-size: 20px;
        color: #8d9099;
        line-height: 32px;
        font-weight: normal;
      }

      .indicator-rate {
        display: flex;
        font-family: DiDiSans-Pro-Thin;
        font-size: 20px;
        color: #8d9099;
        line-height: 32px;
        font-weight: 200;
      }
    }
  }
}
.indicator-wrap-horizontal {
  justify-content: flex-start;
  flex-wrap: nowrap;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  &::-webkit-scrollbar {
    display: none;
  }
  .indicator-item {
    width: 300px;
    flex-shrink: 0;
    margin-top: 0;
    margin-right: 24px;
    text-align: left;
  }
  .indicator-itemlast-child {
    margin-right: 0;
  }
  .indicator-rate {
    display: -webkit-box !important;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    overflow: hidden;
    box-sizing: border-box;
    padding-right: 24px;
    text-align: left;
  }
}
</style>
